import React from 'react'
import { PrimaryService_ID } from 'features/incidents/components/enums'
import { ServiceTabs } from 'components/serviceTabs/ServiceTabs'

import { DefenderInventory, EDRInventory, CoveInventory, PatchInventory } from './InventoryProvider'

interface IInventoryProps {
  activeServices?: number[]
  setTabNumber: (tab: number) => void
  tabNumber: number | null
}

const InventoryTabs = ({ activeServices, setTabNumber, tabNumber }: IInventoryProps) => {
  return (
    <div>
      <ServiceTabs activeServices={activeServices} setTabNumber={setTabNumber}>
        {tabNumber && tabNumber === PrimaryService_ID.EDR && <EDRInventory />}
        {tabNumber && tabNumber === PrimaryService_ID.COVE_DATA && <CoveInventory />}
        {tabNumber && tabNumber === PrimaryService_ID.N_SIGHT_PATCH && <PatchInventory />}
        {tabNumber && tabNumber === PrimaryService_ID.WINDOW_DEFENDER && <DefenderInventory />}
      </ServiceTabs>
    </div>
  )
}

export default InventoryTabs
